// extracted by mini-css-extract-plugin
export default {"recommendation-card":"components-general-smart-insights-detail-view-smart-insight-recommendation-list-module__recommendation-card"};